import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import './TrainingSingle.css';

import { PageSidebar, PageTitle } from '../../../components';
import { FaCircleNotch, FaCheck, FaBook, FaUsers, FaLightbulb, FaArrowLeft } from 'react-icons/fa';

// UWAGA: Importujemy teraz 'trainings' (liczba mnoga), upewnij się, że ścieżka jest poprawna
import { training } from '../../../constants'; 

const TrainingSingle = () => {
    // 1. Pobieramy ID z adresu URL
    const { id } = useParams();

    // 2. Przewijamy stronę do góry po załadowaniu (UX fix)
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [id]);

    // 3. Szukamy szkolenia. Używamy parseInt, bo id z URL to string, a w bazie masz number
    const trainingItem = training.find(t => t.id === parseInt(id));

    // 4. Zabezpieczenie: Jeśli nie znaleziono szkolenia, wyświetl komunikat zamiast błędu
    if (!trainingItem) {
        return (
            <div className="page-single" style={{ display: 'block', textAlign: 'center', padding: '10rem 0' }}>
                <h2>Nie znaleziono takiego szkolenia.</h2>
                <Link to="/szkolenia" className="btn btn-primary" style={{ marginTop: '1rem', display: 'inline-block', color: 'var(--green)', fontWeight: 'bold' }}>
                    <FaArrowLeft /> Wróć do listy
                </Link>
            </div>
        );
    }

    return (
        <>
            <PageTitle title={trainingItem.title} page={'Szkolenia'} />

            <section className='event-single page-single'>

                {/* Lewa kolumna - Treść główna */}
                <div className='event-info page-info'>
                    
                    {/* Przycisk powrotu */}
                    <div className="back-link-wrapper">
                        <Link to="/szkolenia" className="back-link">
                            <FaArrowLeft /> Powrót do listy szkoleń
                        </Link>
                    </div>

                    <div className='content'>

                        <h3 className='main-heading'>{trainingItem.title}</h3>
                        <p className='subtitle'>
                            {trainingItem.subtitle}
                        </p>

                        {/* 1. Cel szkolenia */}
                        {trainingItem.goals && (
                            <div className='sub-section'>
                                <h3 className='sub-heading'><FaLightbulb className='icon-header' /> Cel szkolenia</h3>
                                <ul>
                                    {trainingItem.goals.map((goal, index) => (
                                        <li key={index}><FaCheck className='icon green-icon' />{goal}</li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {/* 2. Dla kogo? */}
                        {trainingItem.targetAudience && (
                            <div className='sub-section'>
                                <h3 className='sub-heading'><FaUsers className='icon-header' /> Dla kogo?</h3>
                                <ul>
                                    {trainingItem.targetAudience.map((item, index) => (
                                        <li key={index}><FaCircleNotch className='icon small-icon' />{item}</li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {/* 3. Efekty (szary box) - opcjonalne renderowanie */}
                        {trainingItem.outcomes && (
                            <div className='sub-section highlight-box'>
                                <h4>Po szkoleniu uczestnik / efekty:</h4>
                                <ul>
                                    {trainingItem.outcomes.map((outcome, index) => (
                                        <li key={index}><FaCheck className='icon green-icon' />{outcome}</li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {/* 4. Program szkolenia */}
                        {trainingItem.program && (
                            <div className='sub-section'>
                                <h3 className='sub-heading'><FaBook className='icon-header' /> Program szkolenia</h3>

                                <div className='program-modules'>
                                    {trainingItem.program.map((module, index) => (
                                        <div key={index} className='module-item'>
                                            <h4 className='module-title'>
                                                {module.title}
                                            </h4>
                                            <ul>
                                                {module.points.map((point, idx) => (
                                                    <li key={idx}><FaCircleNotch className='icon small-icon' />{point}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* 5. Metody pracy */}
                        {trainingItem.methods && (
                            <div className='sub-section'>
                                <h3 className='sub-heading'>Metody pracy</h3>
                                <div className='methods-list'>
                                    <ul>
                                        {trainingItem.methods.map((method, index) => (
                                            <li key={index}><FaCheck className='icon green-icon' />{method}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        )}

                    </div>
                </div>

                {/* Prawa kolumna - Sidebar */}
                <div className='sidebar-wrapper'>

                    <PageSidebar
                        heading={'Szczegóły'}
                        details={{
                            'Czas trwania': trainingItem.details.duration,
                            'Poziom': trainingItem.details.level,
                            'Zapisy': trainingItem.details.deadline,
                        }}
                        button={{ link: 'contact', title: 'Zapisz się' }}
                    />

                    <div className='sidebar-promo-image'>
                        {/* Zabezpieczenie na wypadek braku zdjęcia */}
                        {trainingItem.image && <img src={trainingItem.image} alt={trainingItem.title} />}
                        <div className='promo-overlay'>
                            <span>Dołącz do nas!</span>
                        </div>
                    </div>

                </div>

            </section>
        </>
    );
}

export default TrainingSingle;